export default __webpack_public_path__ + "static/media/com-adidas.ebd69817.mp4";